import { render, staticRenderFns } from "./SemesterNumberedSelectbox.vue?vue&type=template&id=35a6921e"
import script from "./SemesterNumberedSelectbox.vue?vue&type=script&lang=js"
export * from "./SemesterNumberedSelectbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports